import React, {useEffect, useState} from 'react'
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { fetchProducts, deleteProduct } from '../utils/api';
import { toast, ToastContainer } from "react-toastify";
import EditProductModal from '../components/EditProductModal';

const Products = () => {
    const [products, setProducts] = useState([]);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);

    useEffect(() => {
        getProducts();
    }, [])

    const getProducts = async () => {
        try {
            const data = await fetchProducts();
            setProducts(data)
        } catch (error) {
            console.error("Feil ved henting av produckter")
        }
    }

    const handleDelete = async (id) => {
        if (window.confirm("Er du sikker på at du vil slette dette produktet?")) {
            try {
                await deleteProduct(id);
                setProducts(products.filter((product) => product._id !== id));
                toast.success("Produktet ble slettet!");
            } catch (error) {
                toast.error("Kunne ikke slette produktet.");
                console.error("Feil:", error);
            }
        }
    };

    const onProductUpdated = (status) => {
        if (status === "success"){
            toast.success("Produkt Oppdatert!")
        } else {
            toast.error("Feil, Produkt ble ikke oppdatert!")
        }

        getProducts();
    }


    return (
        <div className='p-4 md:p-6'>
            <ToastContainer position='top-right' autoClose={2000} />
            <div className='flex flex-col sm:flex-row sm:justify-between sm:items-center mb-6'>
                <h1 className='text-xl md:text-2xl font-bold text-gray-800'>Produkter</h1>

                <button className='bg-green-600 hover:bg-green-700 px-4 py-2 rounded flex items-center justify-center gap-2'>
                    <Link to="/create-product" className='text-center text-white text-sm'>
                        Nytt Produkt
                    </Link>
                    <FaPlus color='#fff' size={16}/>
                </button>
            </div>

            <div className='grid grid-cols-1 md:grid-cols-3 lg:grid-cols 4 gap-6'>
                {products.map((product) => (
                    <div key={product._id} className='bg-white shadow-md rounded-lg overflow-hidden p-4 flex flex-col'>
                        <img src={product.image} alt={product.title} className="w-full h-40 object-contain rounded-md mb-4" />
                        <div className='flex justify-between items-center'>
                            <span className='max-w-[80%]'>
                                <h2 className="text-lg font-bold text-gray-800">{product.name}</h2>
                                <p className="text-gray-600 text-sm mt-1">{product.description}</p>
                            </span>
                            <p className="text-green-700 font-bold mt-2 text-end">{product.price} Kr</p>
                        </div>

                        <div className="flex justify-between items-center mt-4">
                            <button onClick={() => { setSelectedProductId(product._id); setIsEditModalOpen(true); }} className="flex items-center gap-1 text-blue-600 hover:text-blue-800">
                                <FaEdit /> Rediger
                            </button>
                            <button onClick={() => handleDelete(product._id)} className="flex items-center gap-1 text-red-600 hover:text-red-800">
                                <FaTrash /> Slett
                            </button>
                        </div>
                    </div>
                ))}

            </div>

            <EditProductModal productId={selectedProductId} isOpen={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} onProductUpdated={onProductUpdated} />
        </div>
    )
}

export default Products